import React from 'react';
import withIcon from '../utilities/withIcon';

const IconListBulleted = () => {
  return (
    <g>
      <path d="M1.25 12.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm14.004.5c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H5.746A.746.746 0 0 1 5 13.754v-.008c0-.412.334-.746.746-.746h9.508zM1.25 6.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm14.004.5c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H5.746A.746.746 0 0 1 5 8.004v-.008c0-.412.334-.746.746-.746h9.508zM1.25 1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm14.004.5c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H5.746A.746.746 0 0 1 5 2.254v-.008c0-.412.334-.746.746-.746h9.508z" />
    </g>
  );
};

export default withIcon(IconListBulleted);
